// extracted by mini-css-extract-plugin
export default {"main":"login_main__8B+bm","submain":"login_submain__i1s8M","loginP":"login_loginP__zM2M8","loginmain":"login_loginmain__1tK-g","sidebarMain":"login_sidebarMain__hY-RA"};